import Box from '@mui/material/Box';

import { ImageUpload } from '@/components/form/ImageUpload';
import { LOGO_MAX_BYTES } from '@/lib/images';

import { SAMPLE_IMAGE } from '../sampleData';
import { State } from '../State';

/** Long enough to see the progress bar; nothing is actually sent anywhere. */
const pretendToSend = () => new Promise((resolve) => setTimeout(resolve, 600));

export function ImageUploadExamples() {
  return (
    <>
      <State
        title="Empty"
        note="Choosing a file here previews it locally; nothing leaves the browser."
      >
        <Box sx={{ maxWidth: 360 }}>
          <ImageUpload
            label="Organization logo"
            alt="Organization logo"
            src={null}
            maxBytes={LOGO_MAX_BYTES}
            onUpload={pretendToSend}
            onRemove={() => undefined}
          />
        </Box>
      </State>

      <State title="With an image">
        <Box sx={{ maxWidth: 360 }}>
          <ImageUpload
            label="Cover image"
            alt="A sample cover image"
            src={SAMPLE_IMAGE}
            maxBytes={LOGO_MAX_BYTES}
            onUpload={pretendToSend}
            onRemove={() => undefined}
          />
        </Box>
      </State>

      <State title="A failed upload" note="Choose any file: this one always refuses it.">
        <Box sx={{ maxWidth: 360 }}>
          <ImageUpload
            label="Logo that fails"
            alt="Logo that fails"
            src={null}
            maxBytes={LOGO_MAX_BYTES}
            onUpload={async () => {
              await pretendToSend();
              throw new Error('That image could not be uploaded. Please try again.');
            }}
            onRemove={() => undefined}
          />
        </Box>
      </State>
    </>
  );
}
